import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DownloadOutlined } from '@ant-design/icons-vue';
import type { SizeType } from 'ant-design-vue/es/config-provider';
import { ref } from 'vue';
interface props {
    size: any;
    type: any;
    classBtn: any;
    icon: any;
    text: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Add',
  props: {
    size: { default: 'default' },
    type: { default: 'primary' },
    classBtn: { default: 'btn-add-cmn' },
    icon: { default: 'bi bi-plus-lg' },
    text: { default: 'Add' }
  },
  setup(__props: any) {

const propsData = __props;

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_button, {
    class: _normalizeClass(_ctx.classBtn),
    type: _ctx.type,
    size: _ctx.size
  }, {
    default: _withCtx(() => [
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.icon)
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
    ]),
    _: 1
  }, 8, ["class", "type", "size"]))
}
}

})